import { useSortable } from '@dnd-kit/react/sortable';
import React from 'react';
import { TASK_TYPE, TREATMENT_TYPE } from '../../../../../../util/varibles/constants';
import { IPropsChildren, TTaskTreatment } from "../../../../../../util/varibles/interface";
import { IUnitWhenEdit } from "../../EditOperationContext";
import stylesContainer from "../style.module.scss";
import Setting from "./Setting";
import styles from "./style.module.scss";

interface IProps extends IPropsChildren {
    unit: IUnitWhenEdit
    data: TTaskTreatment;
    isError: boolean
    isAllowDrag: boolean
    dragGroup: string

    onChange(change: Partial<TTaskTreatment>): void

    onDelete?(): void
}

const WrapperTask: React.FC<IProps> = ({
    data,
    unit,
    isAllowDrag,
    isError,
    dragGroup,
    children,
    onChange,
    onDelete
}) => {
    const { elementId, type, group_id, treatment_type } = data;
    const { isLock } = unit;
    const isTaskGroup = type === TASK_TYPE.TREATMENT && treatment_type === TREATMENT_TYPE.SORTING;
    const canDrag = isAllowDrag && Boolean(type) && !isTaskGroup;
    const { ref, handleRef, isDragging } = useSortable({
        id: group_id,
        index: data.index || 0,
        type: isTaskGroup ? 'taskGroup' : 'task',
        accept: ['task', 'taskGroup'],
        group: dragGroup,
        disabled: !canDrag,
    });

    return <div
        ref={ref}
        className={styles['container-task']}
        data-dragging={isDragging || undefined}
    >
        {canDrag &&
            <button
                ref={handleRef}
                className={stylesContainer['bt-drag']}
                data-drag-handle
                type="button"
                aria-label="Drag task"
            >
                ⠿
            </button>}
        <div
            id={`${elementId}`}
            className={[styles.task, stylesContainer['wrapper-task']].join(' ')}
            data-task={type}
            data-error={isError}
            data-allow-drag={isAllowDrag}
        >
            {children}
            <div className={[styles.menu, stylesContainer.menu].join(' ')}>
                {!isLock && <Setting data={data} onChange={onChange} onDelete={onDelete} />}
            </div>
        </div>
    </div>;
};

export default WrapperTask;
